import logo from "assets/images/sculpt_survey_logo.svg";
import newlogo from "assets/images/sculpt_survey_logo.svg";
import newMinimizedLogo from "assets/images/sculpt_survey_logo.svg";


export const appLogo = newlogo;
export const minimizedLogo = newMinimizedLogo;
export const surveyName = "Mtraction Survey Platform"
